// extracted by mini-css-extract-plugin
export default {"advertCard":"c-a_is","advertCardNum":"c-a_it"};